<div
  class="contact-overlay"
  [class.d-none]="!popupModalService.hasContent()"
  (click)="popupModalService.close()"
>
  <div class="contact-modal" (click)="$event.stopPropagation()">
    <ng-template appPopupModalHost></ng-template>
  </div>
</div>
